'use client';

import { createContext, useContext } from 'react';

export type DrawerOrPopoverMenuContextValue = {
  /** True while the popover is the menu on screen, false for the drawer. */
  isAboveBreakpoint: boolean;
  open: boolean;
  /** Opens or closes whichever menu is on screen, e.g. from a row that stays open while it works. */
  setOpen: (open: boolean) => void;
};

const DrawerOrPopoverMenuContext = createContext<DrawerOrPopoverMenuContextValue | null>(null);

export const DrawerOrPopoverMenuProvider = DrawerOrPopoverMenuContext.Provider;

export const useDrawerOrPopoverMenu = () => {
  const context = useContext(DrawerOrPopoverMenuContext);

  if (!context) {
    throw new Error('DrawerOrPopoverMenu parts must be rendered inside a DrawerOrPopoverMenu.');
  }

  return context;
};
